import styled from '@emotion/styled';
import { typography, color, space } from 'styled-system';

const AtomicText = styled('p')`
  font-family: 'Nunito Sans';
  font-size: 12pt;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 0px;
  ${space}
  ${typography}
  ${color}
`;

export default AtomicText;
